import React from "react";
import { Autocomplete, TextField } from "@mui/material";

function MyAutoComplete({ onChange, list, title, label, ...rest }) {
  return (
    <Autocomplete
      onChange={onChange}
      {...rest}
      getOptionLabel={(option) => option[title] || ""}
      id="controllable-states-demo"
      options={list}
      fullWidth
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" fullWidth />
      )}
    />
  );
}

export default MyAutoComplete;
